
import { useI18n } from 'components/lni18n';
import React from 'react';
import A0 from './a0';
import A2 from './a2';
import A1 from './a1';
import ScrollContent from 'components/ScrollContent';
import LnIcon from 'components/LnIcon';

const Accessibility = () => {

    const { languageService: t } = useI18n();

    const getComponent = () => {
        switch (t.currentLanguage.Id) {
            case 0:
                return <A0 />;
            case 1:
                return <A1 />;
            case 2:
                return <A2 />;
            default:
                return <A0 />;
        }
    }

;


    return <ScrollContent scrollname="course-overview">
        <div className="card-box big-card-box">
            <div className="card-header ln-nostyle d-flex justify-content-between">
                <h3>
                    <LnIcon className="header-icon" name="eye-icon" />
                    {t.getText('accessibility')}
                </h3>
                <div>
                    
                </div>
            </div>

            <div className="card-body pt-5 max-col-width">
                {getComponent()}
            </div>

        </div>
    </ScrollContent>


}

export default Accessibility;